import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { label: 'A Santa Carne', path: '/' },
    { label: 'Parceiros', path: '/parceiros' },
    { label: 'Produtos', path: '/produtos' },
    { label: 'Eventos', path: '/eventos' },
    { label: 'Catálogo', path: '/catalogo' },
    { label: 'Contacto', path: '/contacto' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#1a1a1a]/95 backdrop-blur-md border-b border-[#B8860B]/20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center h-20 relative">
          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden absolute left-0 text-white hover:text-[#B8860B] transition-colors"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>

          {/* Nome Santa Carne - BRANCO */}
          <Link to="/" className="flex-shrink-0 transition-all hover:opacity-80">
            <h1 className="text-2xl sm:text-3xl font-bold text-white tracking-wider" style={{fontFamily: "'Playfair Display', serif"}}>
              SANTA CARNE
            </h1>
          </Link>
        </div>

        {/* Desktop Menu */}
        <nav className="hidden lg:flex items-center justify-center space-x-10 pb-4">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-xs font-medium tracking-widest uppercase transition-all hover:text-[#B8860B] ${
                isActive(item.path)
                  ? 'text-[#B8860B]'
                  : 'text-[#E8DDCB]/80'
              }`}
              style={{fontFamily: "'Inter', sans-serif"}}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <nav className="lg:hidden py-6 space-y-4 border-t border-[#B8860B]/20 bg-[#1a1a1a]">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block text-sm font-medium tracking-widest uppercase transition-colors text-center ${
                  isActive(item.path)
                    ? 'text-[#B8860B]'
                    : 'text-[#E8DDCB]/80 hover:text-[#B8860B]'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
